import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
import { GetImsVendorLoadData } from '@/api/MaintainDeliveryNote2';
export default {
  data: function data() {
    return {
      isShowDELIVERY_NO: true,
      // 输入送货单号
      isShowVENDOR_CODE: true,
      // 输入供应商代码
      isShowVENDOR: true,
      // 输入供应商
      isShowSeach: true,
      // 查询
      isShowAdd: true,
      // 新增
      isShowExport: false,
      // 数据导出
      isShowBlack: false,
      // 返回
      isShowSave: false,
      // 保存
      isShowAddRow: false,
      // 新增明细
      isShowEditOrder: false,
      // 修改明细
      isShowAuditOrder: false,
      // 审核
      isShowUnAuditOrder: false,
      // 反审核
      isShowPrinter: false,
      // 打印
      isShowNext: true,
      // 上一张下一张
      isShowCancellation: false,
      // 作废
      isShowCancel: false,
      // 取消
      isShowSelectOrder: false,
      // 选择送货单
      isShowCreatePartBarcode: false,
      // 生成标签
      isShowDetailExport: false,
      // 明细导出
      VENDOR_CODE: null,
      // 供应商
      selectLoading: false,
      vendorOptions: [],
      DELIVERY_NO: null,
      // 送货单号
      OrderList: [],
      // 单据列表
      currentIndex: null,
      nextIndex: null,
      orderStatus: null,
      // 单据状态
      orderInfo: {} // 单据内容

    };
  },
  mounted: function mounted() {
    var _this = this;

    this.Bus.on('onClickDELIVERY_NO', function (data, currentIndex, OrderList) {
      // console.log('TabelToolBar---data',data);
      // console.log('TabelToolBar---currentIndex',currentIndex);
      // console.log('TabelToolBar---OrderList',OrderList);
      _this.orderInfo = data;
      _this.OrderList = OrderList;
      _this.currentIndex = currentIndex;

      _this.controlBtnShow(data.STATUS);
    }); // 监听审核成功

    this.Bus.on('AuditOrderSuccess', function () {
      _this.controlBtnShow(2);
    }); // 监听反审核成功

    this.Bus.on('UnCheckBillOrderSuccess', function () {
      _this.controlBtnShow(1);
    }); // 监听作废成功

    this.Bus.on('CancelBillSuccess', function () {
      _this.controlBtnShow(3);
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/DeliveryCode', ['setOrderStatu'])), {}, {
    // 设置状态
    setStatus: function setStatus(status) {
      // console.log(status);
      this.controlBtnShow(status);
    },
    // 明细导出
    handleDetailExport: function handleDetailExport() {
      this.$emit('onHandleDetailExport');
    },
    // 组合打印内箱标签
    handlePrintParBarcodeGroup: function handlePrintParBarcodeGroup() {
      // this.Bus.emit('onPrintOuterBoxLabel')
      this.$emit('onHandlePrintParBarcodeGroup');
    },
    // 点击导出--列表
    handelExportListData: function handelExportListData() {
      console.log(1);
      this.Bus.emit('onHandelExportListData');
    },
    // 点击作废
    handelCancelBill: function handelCancelBill() {
      this.Bus.emit('onCancelBillOrder');
    },
    // 点击反审核
    UnCheckBillOrder: function UnCheckBillOrder() {
      this.Bus.emit('onUnCheckBillOrder');
    },
    // 点击生成标签
    handleCreatePartBarcode: function handleCreatePartBarcode() {
      // this.Bus.emit('onCreateOutBoxBarcode')
      this.$emit('handleCreatePartBarcode');
    },
    // 点击选择送货单
    handleSelectOrder: function handleSelectOrder() {
      // this.Bus.emit('onHandleSelectOrder')
      this.$emit('handleSelectOrder');
    },
    // 控制按钮显示
    controlBtnShow: function controlBtnShow(status) {
      if (status === 1) {
        // 未确认
        this.isShowAuditOrder = true;
        this.isShowUnAuditOrder = false;
        this.isShowEditOrder = true;
        this.isShowPrinter = false;
        this.isShowCancellation = true;
      } else if (status === 2) {
        // 已审核
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = true;
        this.isShowPrinter = true;
        this.isShowCancellation = false;
      } else if (status === 3) {
        // 作废
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = false;
        this.isShowPrinter = false;
        this.isShowCancellation = false;
      } else if (status === 4) {
        // 在途
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = true;
        this.isShowPrinter = true;
        this.isShowAuditOrder = false;
        this.isShowCancellation = false;
      } else if (status === 5) {
        // 收货
        this.isShowPrinter = true;
        this.isShowUnAuditOrder = false;
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowCancellation = false;
      } else if (status === 9) {
        // 全关闭
        this.isShowUnAuditOrder = false;
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowPrinter = false;
        this.isShowCancellation = false;
      }
    },
    // 点击上一张
    handleUpNextOrder: function handleUpNextOrder() {
      // console.log(this.currentIndex);
      // if(this.currentIndex === 0){
      //     this.$message.warning('没有上一张订单了')
      //     return
      // }
      // this.currentIndex = this.currentIndex -= 1
      // let data = this.OrderList[this.currentIndex]
      // this.controlBtnShow(data.STATUS)
      // this.Bus.emit('nextOrder',data)
      this.$emit('getBackOrder');
    },
    // 点击下一张
    handleDownNextOrder: function handleDownNextOrder() {
      // console.log(this.currentIndex);
      // if((this.currentIndex + 1) > this.OrderList.length - 1){
      //     this.$message.warning('没有下一张订单了')
      //     return
      // }
      // this.currentIndex = this.currentIndex += 1
      // let data = this.OrderList[this.currentIndex]
      // this.controlBtnShow(data.STATUS)
      // this.Bus.emit('nextOrder',data)
      this.$emit('nextOrder');
    },
    handleVendorChange: function handleVendorChange() {
      console.log(this.VENDOR_CODE);
    },
    // 点击保存单据
    handleSaveOrder: function handleSaveOrder() {
      // this.Bus.emit('onSaveOuterBoxLabelOrder')
      this.$emit('handleSaveOrder');
    },
    // 点击返回
    handleBlackBtn: function handleBlackBtn() {
      // this.Bus.emit('onHandleBlack_OuterBoxLabelManagement')
      this.$emit('onHandleBlackBtn');
    },
    // 点击修改
    handleEditOrder: function handleEditOrder() {
      this.$emit('handleEditOrder');
    }
  }),
  watch: {
    // 内箱标签管理
    $DeliveryCodeOrderState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.isShowDELIVERY_NO = true;
          this.isShowVENDOR_CODE = true;
          this.isShowVENDOR = true;
          this.isShowSeach = true;
          this.isShowAdd = false;
          this.isShowExport = true;
          this.isShowBlack = false;
          this.isShowSave = false;
          this.isShowAddRow = false;
          this.isShowCancel = false;
          this.isShowSelectOrder = false;
          this.isShowPrinter = false;
          this.isShowEditOrder = false;
          this.isShowDetailExport = false;
          this.isShowNext = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.isShowSeach = false;
          this.isShowBlack = true;
          this.isShowSave = true;
          this.isShowSelectOrder = true;
          this.isShowCreatePartBarcode = false;
          this.isShowPrinter = false;
          this.isShowEditOrder = false;
          this.isShowDetailExport = false;
          this.isShowNext = false;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowSeach = false;
          this.isShowBlack = true;
          this.isShowSave = false;
          this.isShowSelectOrder = false;
          this.isShowCreatePartBarcode = true;
          this.isShowPrinter = true;
          this.isShowEditOrder = true;
          this.isShowDetailExport = true;
          this.isShowNext = true;
        } else if (nawValue === 'editOrder') {
          this.isShowBlack = true;
          this.isShowAdd = false;
          this.isShowEditOrder = false;
          this.isShowSave = true; // 保存

          this.isShowExport = false; // 数据导出

          this.isShowCreatePartBarcode = false;
          this.isShowPrinter = false;
          this.isShowSelectOrder = true;
          this.isShowDetailExport = false;
          this.isShowNext = false;
        }
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$DeliveryCodeOrderState', 'AnnouncementState'])),
  beforeDestroy: function beforeDestroy() {
    this.Bus.off('AuditOrderSuccess');
    this.Bus.off('UnCheckBillOrderSuccess');
    this.Bus.off('CancelBillSuccess');
    this.Bus.off('onClickDELIVERY_NO');
  }
};